import { useSessionStorage } from '@vueuse/core';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { RoutePage } from '@/interface/enum';
import { useBetSlipStore } from '@/stores/betSlip/betSlipStore';
import { useSingleModeBetSlipStore } from '@/stores/betSlip/singleModeBetSlipStore';
import { useFeatureToggleStore } from '@/stores/featureToggleStore';
import { useProductPlatformStore } from '@/stores/productPlatformStore';

export function useJackpotDisplay() {
    const isDisplayJackpotWidgetSessionStorage = useSessionStorage('isDisplayJackpotWidget', true);

    const { isJackpotEnabled } = storeToRefs(useFeatureToggleStore());
    const { isComponentInPp } = storeToRefs(useProductPlatformStore());
    const { isShowSingleModeBetSlip } = storeToRefs(useBetSlipStore());
    const { hasTickets: hasSingleModeBetSlipTickets } = storeToRefs(useSingleModeBetSlipStore());

    const route = useRoute();

    const isSingleModeBetSlipShowingTickets = computed(() => (
        isShowSingleModeBetSlip.value && hasSingleModeBetSlipTickets.value
    ));

    const isShowJackpotWidget = computed(() => {
        if (!isJackpotEnabled.value) return false;
        if (isComponentInPp.value) return false;
        if (!isDisplayJackpotWidgetSessionStorage.value) return false;
        if (isSingleModeBetSlipShowingTickets.value) return false;

        return route.name && route.name !== RoutePage.Jackpot;
    });

    return {
        isDisplayJackpotWidgetSessionStorage,
        isShowJackpotWidget,
    };
}
